import React from 'react';
import s from './About.module.scss';

import aboutimg from './assets/casa1.jpg';

//Material UI
import {
	Grid,
	Box
} from '@mui/material';


const About = () => {

	return(
		<Grid container className={s.container} id='about'>
			<Grid item xs={1} className={s.linecontainer}>
				<Box className={s.line1}></Box>
					<p>03</p>
				<Box className={s.line2}></Box>
				
			</Grid>

			<Grid item container xs={12} className={s.content}>
				<Grid item xs={10} className={s.title}>
					<h3>Sobre Nosotros</h3>
				</Grid>

				<Grid item container xs={12} className={s.data}>
					
					<Grid item container xs={11} sx={{display: "flex", justifyContent: 'flex-end', alignItems: 'center', height: '90%'}}>
						<Grid item lg={5} md={11} xs={11} sx={{display: "flex", flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-start', padding: '30px', zIndex: 10}}>
							
							<p style={{margin: 0, marginTop: 13, fontFamily: 'Product sans, sans-serif',fontSize: '1.3rem', fontWeight: 300, color: '#EEEEEE', textAlign: 'justify'}}>
							<strong>En Fustec, contamos con más de 15 años de experiencia sólida en seguridad electrónica en Argentina. Durante este tiempo, hemos recorrido diversas provincias, brindando soluciones de seguridad tanto para hogares como para negocios.</strong><br/><br/>
							Nos enorgullece trabajar con todas las marcas habilitadas, lo que nos permite ofrecer a nuestros clientes una amplia variedad de opciones de seguridad.<br/><br/>
							Además, colaboramos estrechamente con las empresas más confiables de monitoreo y videoverificación para brindar un servicio de seguridad inigualable las 24 horas del día, los 7 días de la semana.
							<br/>
							<br/>
							<strong>En Fustec, la seguridad es nuestra pasión. Estamos comprometidos a proteger lo que más valoras. </strong>
							</p>
						</Grid>
						<img src={aboutimg} alt="about_mm" style={{height: '75%', width: '100vw', objectFit: 'cover', position: 'absolute', filter: 'brightness(0.6)', left: 0}}/>
					</Grid>

				</Grid>
			</Grid>
		</Grid>
	)
}

export default About;